import L from "leaflet";

const RouteAnimationLabelIcon = (label: string) => {
  return L.divIcon({
    className: "route-label",
    html: `
        <div class="relative">
          <span class="absolute -top-16 -translate-x-1/2 whitespace-nowrap 
          px-2 py-1 rounded text-xs shadow-md tracking-wider bg-yellow-200
          ">
            ${label}
          </span>
        </div>
      `,
    iconSize: [40, 40],
    iconAnchor: [0, 0],
  });
};

export default RouteAnimationLabelIcon;
